module.exports = "/_next/static/images/vloerisolatie-f6a35963c1ee36c520d8f025eda8623e.jpg";